import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FadeIn from 'react-fade-in';
import JBImage from 'components/essentials/JBImage';
import IconStarFull from 'components/icons/iconStarFull';
import isClient from 'commons/isClient';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import PDPPriceSection from '../../PDPPriceSection';
const PDPUpSellFlyOut = t0 => {
  const $ = _c(28);
  const {
    top,
    name,
    price,
    imageUrl,
    hidePrice,
    salePrice,
    promotion,
    optionPrice,
    description,
    totalReviews,
    averageRating
  } = t0;
  const containerRef = useRef(null);
  const [height, setHeight] = useState(300);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setTimeout(() => {
        const theHeight = containerRef.current?.getBoundingClientRect().height;
        if (theHeight) {
          setHeight(theHeight);
        }
      }, 100);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let absTop = 0;
  if (top < 0) {
    absTop = -top;
  } else {
    if (isClient() && window.innerHeight < top + height) {
      absTop = window.innerHeight - height - top;
    }
  }
  let t3;
  if ($[2] !== absTop) {
    t3 = {
      top: absTop
    };
    $[2] = absTop;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== imageUrl) {
    t4 = imageUrl && <JBImage src={imageUrl} width={400} loader={false} lazy={false} className="h-[156px] object-contain" />;
    $[4] = imageUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== name) {
    t5 = <div className="text-xl font-bold mb-1">{name}</div>;
    $[6] = name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== averageRating || $[9] !== hidePrice || $[10] !== optionPrice || $[11] !== price || $[12] !== promotion || $[13] !== salePrice || $[14] !== totalReviews) {
    t6 = !hidePrice && <div className="flex text-xl font-bold mb-1"><PDPPriceSection priceObj={price} salePrice={salePrice} promotion={promotion} optionPrice={optionPrice} variant="PDPUpSellFlyOut" /><div className="flex items-center ml-4 [&_span]:mr-2">{averageRating > 0 && <><span><IconStarFull /></span><span className="text-base font-bold">{averageRating}/5</span></>}{totalReviews > 0 && <span className="text-base">({totalReviews} review{totalReviews > 1 ? "s" : ""})</span>}</div></div>;
    $[8] = averageRating;
    $[9] = hidePrice;
    $[10] = optionPrice;
    $[11] = price;
    $[12] = promotion;
    $[13] = salePrice;
    $[14] = totalReviews;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="pt-4 px-4 pb-0">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== description) {
    t8 = <SanitizedHtml className="pt-0 px-4 pb-4 text-gray text-xs [&_p]:text-xs [&_p]:mb-4 [&_ul]:m-0 [&_ul]:pt-0 [&_ul]:pr-0 [&_ul]:pb-0 [&_ul]:pl-4 [&_ul_li]:mb-2" html={description} />;
    $[19] = description;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="border border-solid border-gray-light8 rounded-bl-lg rounded-br-lg">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t3 || $[25] !== t4 || $[26] !== t9) {
    t10 = <FadeIn><div ref={containerRef} className="absolute z-10 left-[-450px] top-0 w-[400px] min-h-[255px] bg-white ml-[1.9rem] rounded-lg overflow-hidden" style={t3}>{t4}{t9}</div></FadeIn>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
PDPUpSellFlyOut.propTypes = {
  top: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.object,
  optionPrice: PropTypes.number,
  salePrice: PropTypes.number,
  hidePrice: PropTypes.bool,
  imageUrl: PropTypes.string,
  description: PropTypes.string,
  totalReviews: PropTypes.number,
  averageRating: PropTypes.number,
  promotion: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string
  })
};
export default PDPUpSellFlyOut;